module.exports = __webpack_public_path__ + "static/media/illustration-offroad-adventure.823ae255.svg";